import "./style.css";
import video0 from "./_static_0.mp4";
import video1 from "./_static_1.mp4";
import video2 from "./_static_2.mp4";
import video3 from "./_static_3.mp4";

const videos = [video0, video1, video2, video3];

// Wait for DOM to be ready
document.addEventListener("DOMContentLoaded", () => {
  const videoSource = document.getElementById("video-source");
  const videoElement = videoSource.parentElement;

  // Set random video source
  videoSource.src = videos[Math.floor(Math.random() * videos.length)];

  // Reload the video element to apply the new source
  videoElement.load();
});
